export enum PriceFormat {
  NoFractionDigits = 'no-fraction-digits',
  /**
   * We need the standard price format to keep compatibility with our old behavior,
   * which is no fraction digits on all screens except the checkout dialog, where we show two fraction digits.
   */
  Standard = 'standard',
  TwoFractionDigits = 'two-fraction-digits',
  Automatic = 'automatic', // 12 => 12, 12.3 => 12.30
}
